<template>
  <div>
    <card v-loading="loading" :title="$t('auditLogs.single.title')">
      <span v-if="error">{{ JSON.stringify(error) }}</span>
      <span v-else-if="details">
      <audit-log-details :details="details"/>
    </span>
    </card>
  </div>
</template>
<script>
import AuditLogDetails from '@/components/AuditLog/AuditLogDetails'
import {mapActions, mapState} from "vuex";

export default {
  name: 'auditLogPage',
  components: {
    AuditLogDetails
  },
  methods: {
    ...mapActions(['GetAuditLog']),
  },
  computed: {
    ...mapState({
      loading: state => state.audit_log.loading,
      details: state => state.audit_log.data,
      error: state => state.audit_log.error,
    }),
  },
  mounted() {
    this.GetAuditLog({id: this.$route.params.id})
  }
};
</script>
<style>
</style>
